import React, { useEffect } from 'react';
import '../Components/Upload/LoadingPage.css';
import { useSelector } from "react-redux";

const LoadingPage = () => {
  const { user, isAuth } = useSelector((state) => state.user);

  useEffect(() => {
    if (user && user.preferences) {
      const textSize = user.preferences.textSize;

      switch (textSize) {
        case 0: // Small
            document.documentElement.style.setProperty('--font-size-header', '1vw');
            document.documentElement.style.setProperty('--font-size-label', '12px');
            document.documentElement.style.setProperty('--font-size-input', '12px');
            document.documentElement.style.setProperty('--font-size-button', '0.5vw');
            break;
        case 1: // Medium (default)
            document.documentElement.style.setProperty('--font-size-header', '2vw');
            document.documentElement.style.setProperty('--font-size-label', '16px');
            document.documentElement.style.setProperty('--font-size-input', '16px');
            document.documentElement.style.setProperty('--font-size-button', '1vw');
            break;
        case 2: // Large
            document.documentElement.style.setProperty('--font-size-header', '3vw');
            document.documentElement.style.setProperty('--font-size-label', '24px');
            document.documentElement.style.setProperty('--font-size-input', '24px');
            document.documentElement.style.setProperty('--font-size-button', '2vw');
            break;
        default:
          break;
      }
    } else if (!isAuth) { 
      document.documentElement.style.setProperty('--font-size-header', '2vw');
      document.documentElement.style.setProperty('--font-size-label', '16px');
      document.documentElement.style.setProperty('--font-size-input', '16px');
      document.documentElement.style.setProperty('--font-size-button', '1vw');
    }
  }, [user, isAuth]);
  return (
    <div className="loading-container">
      <div className="loader"></div>
      <p className="waiting-text">Please wait</p>
      <p className="loading-text">We are analyzing your document<span className="dots">...</span></p>   
    </div>
  );
};

export default LoadingPage;
